// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/admin_feature.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/admin_feature.proto.
 */
export const file_v1_admin_feature: GenFile = /*@__PURE__*/
  fileDesc("ChZ2MS9hZG1pbl9mZWF0dXJlLnByb3RvEgJ2MSI4ChdMaXN0RmVhdHVyZVVzZXJzUmVxdWVzdBIPCgdmZWF0dXJlGAEgASgJEgwKBGRheXMYAiABKAUijgIKC0ZlYXR1cmVVc2VyEhAKCHVzZXJuYW1lGAEgASgJEhIKCmhhc19hY2Nlc3MYAiABKAgSLgoKZ3JhbnRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKZ3JhbnRlZF9ieRgEIAEoCRI2CgxldmVudF9jb3VudHMYBSADKAsyIC52MS5GZWF0dXJlVXNlci5FdmVudENvdW50c0VudHJ5EikKDmxhc3RfdXNlZF9kYXRlGAYgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRoyChBFdmVudENvdW50c0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoBToCOAEiOgoYTGlzdEZlYXR1cmVVc2Vyc1Jlc3BvbnNlEh4KBXVzZXJzGAEgAygLMg8udjEuRmVhdHVyZVVzZXIiTQoaR2V0RmVhdHVyZVVzZXJVc2FnZVJlcXVlc3QSDwoHZmVhdHVyZRgBIAEoCRIQCgh1c2VybmFtZRgCIAEoCRIMCgRkYXlzGAMgASgFIqgBCg9GZWF0dXJlVXNhZ2VEYXkSJQoKdXNhZ2VfZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSOgoMZXZlbnRfY291bnRzGAIgAygLMiQudjEuRmVhdHVyZVVzYWdlRGF5LkV2ZW50Q291bnRzRW50cnkaMgoQRXZlbnRDb3VudHNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAU6AjgBIkAKG0dldEZlYXR1cmVVc2VyVXNhZ2VSZXNwb25zZRIhCgRkYXlzGAEgAygLMhMudjEuRmVhdHVyZVVzYWdlRGF5Ik0KF1NldEZlYXR1cmVBY2Nlc3NSZXF1ZXN0Eg8KB2ZlYXR1cmUYASABKAkSEAoIdXNlcm5hbWUYAiABKAkSDwoHZW5hYmxlZBgDIAEoCCIaChhTZXRGZWF0dXJlQWNjZXNzUmVzcG9uc2UygQMKE0FkbWluRmVhdHVyZVNlcnZpY2UScgoQTGlzdEZlYXR1cmVVc2VycxIbLnYxLkxpc3RGZWF0dXJlVXNlcnNSZXF1ZXN0GhwudjEuTGlzdEZlYXR1cmVVc2Vyc1Jlc3BvbnNlIiOC0+STAh06ASoiGC92MS9hZG1pbi9mZWF0dXJlcy91c2VycxKAAQoTR2V0RmVhdHVyZVVzZXJVc2FnZRIeLnYxLkdldEZlYXR1cmVVc2VyVXNhZ2VSZXF1ZXN0Gh8udjEuR2V0RmVhdHVyZVVzZXJVc2FnZVJlc3BvbnNlIiiC0+STAiI6ASoiHS92MS9hZG1pbi9mZWF0dXJlcy91c2VyLXVzYWdlEnMKEFNldEZlYXR1cmVBY2Nlc3MSGy52MS5TZXRGZWF0dXJlQWNjZXNzUmVxdWVzdBocLnYxLlNldEZlYXR1cmVBY2Nlc3NSZXNwb25zZSIkgtPkkwIeOgEqIhkvdjEvYWRtaW4vZmVhdHVyZXMvYWNjZXNzQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_api_annotations, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message v1.ListFeatureUsersRequest
 */
export type ListFeatureUsersRequest = Message<"v1.ListFeatureUsersRequest"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * 7 or 30: totals cover today and the days-1 days before it (Vietnam time).
   *
   * @generated from field: int32 days = 2;
   */
  days: number;
};

/**
 * Describes the message v1.ListFeatureUsersRequest.
 * Use `create(ListFeatureUsersRequestSchema)` to create a new message.
 */
export const ListFeatureUsersRequestSchema: GenMessage<ListFeatureUsersRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 0);

/**
 * @generated from message v1.FeatureUser
 */
export type FeatureUser = Message<"v1.FeatureUser"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: bool has_access = 2;
   */
  hasAccess: boolean;

  /**
   * Unset when has_access is false.
   *
   * @generated from field: google.protobuf.Timestamp granted_at = 3;
   */
  grantedAt?: Timestamp;

  /**
   * Empty when unknown or has_access is false.
   *
   * @generated from field: string granted_by = 4;
   */
  grantedBy: string;

  /**
   * Event name -> count over the requested days.
   *
   * @generated from field: map<string, int32> event_counts = 5;
   */
  eventCounts: { [key: string]: number };

  /**
   * Last date with any usage ever; unset if never used.
   *
   * @generated from field: google.type.Date last_used_date = 6;
   */
  lastUsedDate?: Date;
};

/**
 * Describes the message v1.FeatureUser.
 * Use `create(FeatureUserSchema)` to create a new message.
 */
export const FeatureUserSchema: GenMessage<FeatureUser> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 1);

/**
 * @generated from message v1.ListFeatureUsersResponse
 */
export type ListFeatureUsersResponse = Message<"v1.ListFeatureUsersResponse"> & {
  /**
   * @generated from field: repeated v1.FeatureUser users = 1;
   */
  users: FeatureUser[];
};

/**
 * Describes the message v1.ListFeatureUsersResponse.
 * Use `create(ListFeatureUsersResponseSchema)` to create a new message.
 */
export const ListFeatureUsersResponseSchema: GenMessage<ListFeatureUsersResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 2);

/**
 * @generated from message v1.GetFeatureUserUsageRequest
 */
export type GetFeatureUserUsageRequest = Message<"v1.GetFeatureUserUsageRequest"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: int32 days = 3;
   */
  days: number;
};

/**
 * Describes the message v1.GetFeatureUserUsageRequest.
 * Use `create(GetFeatureUserUsageRequestSchema)` to create a new message.
 */
export const GetFeatureUserUsageRequestSchema: GenMessage<GetFeatureUserUsageRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 3);

/**
 * @generated from message v1.FeatureUsageDay
 */
export type FeatureUsageDay = Message<"v1.FeatureUsageDay"> & {
  /**
   * @generated from field: google.type.Date usage_date = 1;
   */
  usageDate?: Date;

  /**
   * @generated from field: map<string, int32> event_counts = 2;
   */
  eventCounts: { [key: string]: number };
};

/**
 * Describes the message v1.FeatureUsageDay.
 * Use `create(FeatureUsageDaySchema)` to create a new message.
 */
export const FeatureUsageDaySchema: GenMessage<FeatureUsageDay> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 4);

/**
 * @generated from message v1.GetFeatureUserUsageResponse
 */
export type GetFeatureUserUsageResponse = Message<"v1.GetFeatureUserUsageResponse"> & {
  /**
   * @generated from field: repeated v1.FeatureUsageDay days = 1;
   */
  days: FeatureUsageDay[];
};

/**
 * Describes the message v1.GetFeatureUserUsageResponse.
 * Use `create(GetFeatureUserUsageResponseSchema)` to create a new message.
 */
export const GetFeatureUserUsageResponseSchema: GenMessage<GetFeatureUserUsageResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 5);

/**
 * @generated from message v1.SetFeatureAccessRequest
 */
export type SetFeatureAccessRequest = Message<"v1.SetFeatureAccessRequest"> & {
  /**
   * @generated from field: string feature = 1;
   */
  feature: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;
};

/**
 * Describes the message v1.SetFeatureAccessRequest.
 * Use `create(SetFeatureAccessRequestSchema)` to create a new message.
 */
export const SetFeatureAccessRequestSchema: GenMessage<SetFeatureAccessRequest> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 6);

/**
 * @generated from message v1.SetFeatureAccessResponse
 */
export type SetFeatureAccessResponse = Message<"v1.SetFeatureAccessResponse"> & {
};

/**
 * Describes the message v1.SetFeatureAccessResponse.
 * Use `create(SetFeatureAccessResponseSchema)` to create a new message.
 */
export const SetFeatureAccessResponseSchema: GenMessage<SetFeatureAccessResponse> = /*@__PURE__*/
  messageDesc(file_v1_admin_feature, 7);

/**
 * AdminFeatureService grants beta features to users and reports their usage.
 * Admin role only.
 *
 * @generated from service v1.AdminFeatureService
 */
export const AdminFeatureService: GenService<{
  /**
   * Every non-admin user with their access and usage totals, granted first.
   *
   * @generated from rpc v1.AdminFeatureService.ListFeatureUsers
   */
  listFeatureUsers: {
    methodKind: "unary";
    input: typeof ListFeatureUsersRequestSchema;
    output: typeof ListFeatureUsersResponseSchema;
  },
  /**
   * One user's usage per day, newest first.
   *
   * @generated from rpc v1.AdminFeatureService.GetFeatureUserUsage
   */
  getFeatureUserUsage: {
    methodKind: "unary";
    input: typeof GetFeatureUserUsageRequestSchema;
    output: typeof GetFeatureUserUsageResponseSchema;
  },
  /**
   * Grants or revokes one feature for one user. Repeating either is a no-op.
   *
   * @generated from rpc v1.AdminFeatureService.SetFeatureAccess
   */
  setFeatureAccess: {
    methodKind: "unary";
    input: typeof SetFeatureAccessRequestSchema;
    output: typeof SetFeatureAccessResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_admin_feature, 0);

